import { useEffect, useState } from "react";
import { CreditCard, FileText } from "lucide-react";

const OPTIONS = [
  { id: "en_ligne", label: "TWINT ou carte", detail: "Paiement en ligne immédiat et sécurisé (Stripe) — TWINT, Visa, Mastercard", icon: CreditCard },
  { id: "facture", label: "Facture", detail: "Payable sous 10 jours par virement", icon: FileText },
];

let configPromise = null;
const stripeConfig = () => {
  if (!configPromise) configPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/stripe/config`).then((r) => r.json()).catch(() => ({ paiement_en_ligne: true }));
  return configPromise;
};

export const PaymentChoice = ({ value, onChange, testidPrefix, compact = false, allowInvoice = true }) => {
  const [enLigne, setEnLigne] = useState(true);
  useEffect(() => { stripeConfig().then((c) => setEnLigne(c.paiement_en_ligne !== false)); }, []);
  useEffect(() => {
    if (!allowInvoice && value === "facture") onChange("en_ligne");
    else if (allowInvoice && !enLigne && value === "en_ligne") onChange("facture");
  }, [allowInvoice, enLigne, value, onChange]);
  return (
    <div className={compact ? "grid grid-cols-1 sm:grid-cols-2 gap-2" : "space-y-3"} role="radiogroup" aria-label="Moyen de paiement">
      {OPTIONS.filter(({ id }) => allowInvoice || id !== "facture").map(({ id, label, detail, icon: Icon }) => {
        const active = value === id;
        const off = id === "en_ligne" && !enLigne;
        return (
          <button type="button" key={id} disabled={off} onClick={() => onChange(id)} data-testid={`${testidPrefix}-paiement-${id}`}
            className={`w-full min-h-12 flex items-center gap-3 text-left rounded-xl border transition-colors duration-300 ${compact ? "px-3 py-3" : "px-6 py-4"} ${
              active ? "border-terra bg-terra/5" : "border-wood/20 hover:border-wood/40"
            } ${off ? "opacity-50 cursor-not-allowed" : ""}`}>
            <Icon className={`w-4 h-4 shrink-0 ${active ? "text-terra" : "text-fumee"}`} />
            <span className="min-w-0">
              <span className={`flex items-center gap-2 text-sm font-medium ${active ? "text-earth font-semibold" : "text-bark"}`}>{label}</span>
              {!compact && <span className="block text-xs text-fumee mt-0.5">{off ? "Momentanément indisponible — réglez par facture" : detail}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
};
